import { Link } from "react-router-dom";
import "./CityCard.css";
import { useTranslation } from 'react-i18next';
import Chip from '@mui/material/Chip';
import ReactCountryFlag from "react-country-flag";
import { countryMap } from "../../../../utils/constants";



const CityCard = ({ id, name, location, pinCount, designsCount, isAdmin, image, country  }) => {
  const state = { id, name, location, pinCount, image };

  const { t } = useTranslation();

  const locationsTitle = `${pinCount} Locations`;
  const designsTitle = `${designsCount} Designs`;
  const url = isAdmin ? `/admin/${name}` : `/${name}`;

  return (
    <div className="city_card_container">
        <Link to={url} state={state} style={{textDecoration: 'none'}}>
          <div className="city_image_wrapper">
            <img className="city_image" src={image} />
            <div style={leftChipStyles}>
              <Chip 
              sx={{
                "& .MuiChip-label": {
                  padding: '4px 12px'
                }
              }} 
              label={locationsTitle} 
              style={{backgroundColor: '#06C067', color: '#fff', fontFamily: 'Manrope', fontSize: '13px', height: '25px', fontWeight: '500'}}/>
            </div>
            <div style={rightChipStyles}>
              <Chip sx={{
                  "& .MuiChip-label": {
                    padding: '4px 12px'
                  }
              }} 
              label={designsTitle} 
              style={{backgroundColor: '#FFFFFF', color: '#06C067', fontFamily: 'Manrope', fontSize: '13px', height: '25px', fontWeight: '500'}}/>
            </div>
          </div>
          <div className="label">
            <div>
                <p className="label_city">{name}</p>
                <p className="label_country">
                  <ReactCountryFlag
                  countryCode={countryMap.get(country)}
                  svg
                  style={{ width: '32px', height: '20px', marginLeft: '-2px' }}
                  title={country}
                  />{country}
                </p>
            </div>
            <div>
              <button 
                className="location_btn"
              >See Locations</button>
            </div>
          </div>
           
        </Link>      
    </div>
  );
};

export default CityCard;

const leftChipStyles = {
  position: "absolute", 
  top: 18, 
  left: 18, 
  zIndex: 50, 
  maxWidth: '110px', 
  height: 20,
};

const rightChipStyles = {
  position: "absolute", 
  top: 18, 
  left: 120, 
  zIndex: 50, 
  maxWidth: '110px', 
  height: 20
};
